export const WEEKS_IN_MINI_CALENDAR = 6;
